export enum PermissionTypes {
  DASHBOARD = 'dashboard',

  STATISTICS = 'statistics',

  MOVIES = 'movies',
  MOVIES__DISTRIBUTORS = 'movies__distributors',

  PLANNING = 'planning',

  TUBE = 'tube',

  KIOSKS = 'kiosks',
  KIOSKS__GENERAL = 'kiosks__general',

  REPORTS = 'reports',
  REPORTS__TB_DATA = 'reports__tb_data',

  ACCOUNT = 'account',
  ACCOUNT__ADMINISTRATION__CINEMAS = 'account__administration__cinemas',
  ACCOUNT__ADMINISTRATION__EMPLOYEES = 'account__administration__employees',
  ACCOUNT__CONFIGURATION__RELEASE_NOTES = 'account__configuration__release_notes',

  MARKETING = 'marketing',
  MARKETING___VOUCHERS_CARDS = 'marketing___vouchers_cards',
  MARKETING___EMAIL_MARKETING = 'marketing___email_marketing',
  MARKETING___CUSTOMERS = 'marketing___customers',

  TRANSACTIONS = 'transactions',

  BOOKING = 'booking',

  WEB_CXCASH = 'web_cxcash',
}
